import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import 'leaflet/dist/leaflet.css';
import '@/assets/scss/app.scss';

Vue.config.productionTip = false;
// Vue.filter('currency', (value, decimalPlaces) => `$${(+value).toFixed(decimalPlaces || 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`);

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    window.event = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', window.event);
  },
  unbind: () => {
    document.body.removeEventListener('click', window.event);
  },
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
